import { Injectable } from '@angular/core';
import { Feature } from 'ol';
import Geometry from 'ol/geom/Geometry';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import { NavaidModel } from '../models/navaid';
import { PointsService } from './points.service';
import { ToolsControlService } from './tools-control.service';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { Fill, Icon, Stroke, Style } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
import { VicentyToolControlService } from './vicenty-tool-control.service';
import { ConfigurationService } from './configuration.service';
import { MapService } from './map.service';
import { ModalControlService } from './modal-control.service';
import { FeatureType } from '../models/EnumTypes';

@Injectable({
  providedIn: 'root'
})
export class NavaidsCoChannelsService {

  active : boolean;
  fullScreenMode : boolean = false;

  selectedNavaids: NavaidModel[];

  // table variables ////////////
  frequencies: string[];
  frequenciesActive: boolean[];
  sameFrequencyNavaids: NavaidModel[][];
  distances: number[][];
  azimuth: number[][];
  //////////////////////////////

  // select on table and map aux variables //
  previousSelectedNavaids: NavaidModel[];
  previousSelectedNavaidFeature: Feature<Geometry>;
  /////////////////////////////////////////

  horizontalUnits: string;

  constructor(public toolsService: ToolsControlService,
              private pointsService : PointsService,
              private vicentyTool : VicentyToolControlService,
              private configurationService : ConfigurationService,
              private mapService : MapService,
              public globalSelectionService: GlobalSelectionControlService,
              private modalService : ModalControlService)
              {}

  ClearVariables(){
    this.selectedNavaids = [];
    this.frequencies = [];
    this.frequenciesActive = [];
    this.sameFrequencyNavaids = [];
    this.previousSelectedNavaids = [];
    this.distances = [];
    this.azimuth = [];
    if (this.previousSelectedNavaidFeature != null){
      this.globalSelectionService.removeSelectedFeature(this.previousSelectedNavaidFeature);
    }
    this.previousSelectedNavaidFeature = undefined;
  }

  openWindow(navaidsPayload: NavaidModel[]): void {
    let allNavaids : NavaidModel[] = this.pointsService.getAllNavaidsFromLayers();
    this.ClearVariables();
    this.active = true;
    this.toolsService.navigationOnTop = true;
    this.horizontalUnits = this.configurationService.currentConfiguration.display.horizontalUnits;
    for (const navaid of navaidsPayload){
      this.selectedNavaids.push(allNavaids.find(nav => nav.id == navaid.id));
    }
    for (let navaid of this.selectedNavaids){
      if (!this.frequencies.includes(navaid.vhfTunFreqInput) && navaid.vhfTunFreqInput != null) {
        this.frequencies.push(navaid.vhfTunFreqInput);
        this.frequenciesActive.push(false);
        const navaidsWithSameFrequency: NavaidModel[] = [];
        // selected navaid always at start of array
        navaidsWithSameFrequency.push(navaid);
        for (const navaidIter of allNavaids){
          (navaidIter.vhfTunFreqInput == navaid.vhfTunFreqInput && navaidIter.id != navaid.id) ? navaidsWithSameFrequency.push(navaidIter) : false;
        }
        this.sameFrequencyNavaids.push(navaidsWithSameFrequency);
        this.distances.push([]);
        this.azimuth.push([]);
      }
    }
    if (this.frequencies.length == 0){
      this.modalService.showMesssageModal("Warning", "There are no NavAids to display.")
    }
  }

  // change and select navaids on table and map functions //////////////////////////////////////////////////
  onClickNavaid(indexFreq: number, indexNav: number, event){
    this.selectNavaidRow(indexFreq, indexNav, event);
    this.selectNavaidOnMap(indexFreq, indexNav);
    this.calculateDistancesAndAzimuth(indexFreq, indexNav);
  }
  private selectNavaidRow(indexFreq: number, indexNav: number, event) : void{
    const navaid = this.sameFrequencyNavaids[indexFreq][indexNav];
    if (event.ctrlKey){
      navaid.isselected ? this.previousSelectedNavaids.splice(this.previousSelectedNavaids.indexOf(navaid), 1) : this.previousSelectedNavaids.push(navaid);
      navaid.isselected = !navaid.isselected;
    } else {
      if (this.previousSelectedNavaids.length > 0) {
        this.previousSelectedNavaids.forEach(nav => nav.isselected = !nav.isselected);
        this.previousSelectedNavaids = [];
      }
      navaid.isselected = true;
      this.previousSelectedNavaids.push(navaid);
    }
  }

  private selectNavaidOnMap(indexFreq: number, indexNav: number){
    const navaid = this.sameFrequencyNavaids[indexFreq][indexNav];
    const navaidFeature: Feature<Geometry> = this.pointsService.getNavaidFeatureFromLayers(navaid.id);
    const layer : VectorLayerDMTR = this.pointsService.navaidsLayers.childLayers[0].layers.find((element) => element.id === navaid.navaidtype.toLowerCase()).olLayer;

    if (this.previousSelectedNavaidFeature != null){
      if (this.selectedNavaids.findIndex(nav => nav.id == this.previousSelectedNavaidFeature.get('id')) == -1){

      }
      this.globalSelectionService.removeSelectedFeature(this.previousSelectedNavaidFeature);
    }

    this.previousSelectedNavaidFeature = navaidFeature;

    this.globalSelectionService.selectNavaidOnMap(navaidFeature, layer);

  }

  private calculateDistancesAndAzimuth(indexFreq: number, indexNav: number){
    const navaid = this.sameFrequencyNavaids[indexFreq][indexNav];
    for (let i = 0; i<this.sameFrequencyNavaids[indexFreq].length; i++){
      if (i == indexNav){
        this.distances[indexFreq][i] = null;
        this.azimuth[indexFreq][i] = null;
        continue;
      }
      const iterNav = this.sameFrequencyNavaids[indexFreq][i];
      // calculate distance
      const distance = Math.abs(VicentyToolControlService.calculateDistance(navaid.latitude, navaid.longitude, iterNav.latitude, iterNav.longitude));
      this.horizontalUnits != 'm' ? this.distances[indexFreq][i] = this.mapService.convertMetersToNauticalMiles(distance) : this.distances[indexFreq][i] = distance;

      // calculate azimuth
      this.azimuth[indexFreq][i] = Math.round(VicentyToolControlService.calculateAzimuth(navaid.latitude, navaid.longitude, iterNav.latitude, iterNav.longitude) * 100) / 100;
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////

  // draw 8db boundary functions /////////////////////////////////////////////////////////////////////
  public deactivate8dbBoundaryLayer(){
    this.globalSelectionService.dbBoundaryLayers.active = false;
     this.globalSelectionService.dbBoundaryLayers.childLayers?.forEach(el => {
       el.hideAll();
       el.status = false;
     });
  }
  public clear8dbDraw(){
    this.pointsService.dbBoundaryLayer.childLayers?.forEach(el => {
      el.layers.forEach(layer => {
        layer.olLayer.getSource().clear();
      })
    });
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////


  cancelWindow():void{
    this.active = !this.active;
    this.toolsService.navigationOnTop = false;
    this.ClearVariables();
    this.deactivate8dbBoundaryLayer();
    this.clear8dbDraw();
  }
}


